export default __webpack_public_path__ + "static/media/Pin_Job_Fuel.0339bb01.svg";